export function unaccent(string: string): string {
  return string.normalize("NFD").replace(/\p{Diacritic}/gu, "");
}
